module.exports = __webpack_public_path__ + "cancellara-dist/img/safilo.96167edd.png";